/**
 * SetUserDeviceUseCase
 *
 * Flutter parity:
 * - lib/services/firebase_messaging_service.dart:98-123 (caller `setDeviceInfo`)
 * - lib/data/data_sources/user_device_data_source.dart:5-38 (writer)
 *
 * Writes the current browser's device id to Firestore `user_device/{userId}`
 * so that the backend's single-device-session listener can detect when the
 * user signs in on a different browser/device and force a sign-out here.
 *
 * Error handling diverges from Flutter intentionally: the web port runs this
 * during app startup (AppInitializer), where a transient Firestore write
 * failure must NOT block boot. We swallow + log via `appLogger.error` so the
 * failure is captured in the analytics pipeline but the app continues to
 * initialize. (Flutter calls this from a less critical lifecycle moment and
 * lets errors bubble to its data-source-level handler.)
 */
import { UserDeviceService } from '@/domain/services/userDevice/userDeviceService';
import { appLogger } from '@/domain/services/analytics/appLogger';

export class SetUserDeviceUseCase {
  async execute(userId: string): Promise<void> {
    try {
      await UserDeviceService.setDeviceInfo(userId);
    } catch (error) {
      appLogger.error(
        'Failed to set user device',
        'SetUserDeviceUseCase', { error: error as Error },
      );
    }
  }
}
